var _path, _g, _circle, _g2, _circle2, _path2, _path3, _path4, _circle3, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 283,
    viewBox: "0 0 377 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29494_251215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 377,
    height: 283
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 155.727C0 188.205 11.7084 217.801 30.9754 240.168C53.0789 265.836 85.1312 281.974 120.859 282.028C136.474 282.052 151.404 278.983 165.118 273.382C172.209 270.485 180.145 270.818 187.013 274.25C195.069 278.271 204.09 280.526 213.616 280.526C217.551 280.526 221.404 280.138 225.131 279.403C235.771 277.311 245.453 272.36 253.404 265.348C258.402 260.94 264.802 258.724 271.342 258.732H271.454C293.067 258.732 313.144 251.891 329.812 240.168C344.713 229.701 356.882 215.337 364.99 198.471C372.059 183.774 376.038 167.171 376.038 149.599C376.038 89.3303 329.21 40.4659 271.454 40.4659C265.566 40.4659 259.797 40.9848 254.169 41.9531C239.268 16.7807 212.583 0 182.142 0C169.29 0 157.106 2.99082 146.199 8.35214C135.827 13.4342 126.605 20.6557 119.062 29.4563C93.4465 29.8825 69.7613 38.6144 50.3757 53.187C19.8606 76.1126 0 113.503 0 155.727Z",
    fill: "url(#paint0_linear_29494_251215)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29494_251215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.038,
    height: 282.028,
    fill: "#00A76F"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 87.7546,
    y: 41.3483,
    width: 193.765,
    height: 193.766
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(19.18px)",
      clipPath: "url(#bgblur_0_29494_251215_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 38.3665,
    cx: 184.637,
    cy: 138.231,
    r: 58.5161,
    fill: "url(#paint1_linear_29494_251215)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_29494_251215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.711 76.791C147.029 76.791 118.807 105.01 118.807 139.689C118.807 174.367 147.029 202.601 181.711 202.601C216.394 202.601 244.616 174.382 244.616 139.703C244.616 105.025 216.394 76.791 181.711 76.791ZM208.816 127.698L177.356 161.564C175.933 163.103 173.988 163.887 172.028 163.887C170.344 163.887 168.675 163.306 167.296 162.145L150.353 147.629C147.305 145.016 146.956 140.443 149.569 137.395C152.183 134.347 156.756 133.984 159.804 136.611L171.448 146.584L198.16 117.828C200.889 114.895 205.477 114.721 208.424 117.45C211.371 120.179 211.531 124.766 208.816 127.698Z",
    fill: "url(#paint2_linear_29494_251215)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.763,
    cy: 78.7343,
    r: 7.05071,
    fill: "#26AB3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.91 77.0966C118.302 74.5772 114.718 74.5772 114.11 77.0966L113.322 80.3601C113.105 81.2605 112.402 81.9635 111.502 82.1808L108.238 82.9686C105.719 83.5768 105.719 87.1605 108.238 87.7687L111.502 88.5564C112.402 88.7738 113.105 89.4768 113.322 90.3771L114.11 93.6406C114.718 96.1601 118.302 96.1601 118.91 93.6406L119.698 90.3771C119.915 89.4768 120.618 88.7738 121.519 88.5564L124.782 87.7687C127.302 87.1605 127.302 83.5768 124.782 82.9686L121.519 82.1808C120.618 81.9635 119.915 81.2605 119.698 80.3601L118.91 77.0966Z",
    fill: "#26AB3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.278 195.244C289.102 194.942 289.97 194.541 290.639 193.96C291.434 193.27 291.757 192.381 291.974 191.446C292.253 190.244 292.364 188.963 292.702 187.76C292.827 187.313 293.068 187.144 293.171 187.069C293.432 186.879 293.696 186.828 293.945 186.847C294.239 186.869 294.643 186.984 294.909 187.491C294.947 187.563 294.996 187.674 295.029 187.825C295.054 187.936 295.069 188.284 295.095 188.427C295.159 188.779 295.212 189.132 295.263 189.487C295.43 190.667 295.526 191.669 296.055 192.753C296.772 194.225 297.49 195.125 298.464 195.524C299.407 195.91 300.533 195.837 301.972 195.535C302.109 195.5 302.245 195.471 302.379 195.447C303.014 195.333 303.62 195.762 303.745 196.411C303.869 197.06 303.466 197.693 302.837 197.836C302.706 197.865 302.577 197.894 302.449 197.919C300.504 198.414 298.252 200.18 296.944 201.726C296.54 202.203 295.95 203.536 295.347 204.386C294.903 205.014 294.403 205.427 293.984 205.573C293.703 205.671 293.466 205.656 293.27 205.607C292.986 205.535 292.75 205.376 292.569 205.125C292.47 204.987 292.379 204.802 292.335 204.566C292.314 204.453 292.312 204.165 292.313 204.034C292.19 203.6 292.04 203.177 291.93 202.739C291.669 201.694 291.157 201.033 290.548 200.159C289.979 199.341 289.368 198.828 288.471 198.418C288.355 198.388 287.414 198.152 287.082 198.016C286.597 197.817 286.365 197.483 286.281 197.303C286.139 196.998 286.124 196.732 286.153 196.51C286.195 196.182 286.338 195.902 286.592 195.675C286.749 195.535 286.984 195.398 287.299 195.331C287.542 195.279 288.187 195.249 288.278 195.244ZM293.796 193.542C293.84 193.642 293.886 193.742 293.936 193.843C294.986 195.999 296.16 197.202 297.588 197.786L297.636 197.805C296.681 198.534 295.816 199.348 295.156 200.128C294.884 200.45 294.523 201.118 294.134 201.802C293.781 200.621 293.203 199.787 292.476 198.742C291.92 197.945 291.338 197.345 290.623 196.856C291.178 196.563 291.707 196.22 292.168 195.82C292.936 195.153 293.444 194.381 293.796 193.542Z",
    fill: "#26AB3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0771 143.914C77.5719 143.726 78.0925 143.475 78.494 143.112C78.9709 142.68 79.1648 142.125 79.295 141.54C79.4622 140.789 79.529 139.989 79.7318 139.236C79.8069 138.957 79.9513 138.851 80.0133 138.805C80.17 138.686 80.3284 138.655 80.4774 138.666C80.6539 138.68 80.8965 138.752 81.056 139.068C81.0788 139.114 81.1083 139.183 81.1282 139.278C81.1427 139.347 81.1521 139.564 81.1675 139.653C81.2059 139.874 81.238 140.094 81.2681 140.316C81.3685 141.053 81.4262 141.68 81.7433 142.357C82.1735 143.277 82.6046 143.84 83.1892 144.089C83.7545 144.33 84.4304 144.285 85.294 144.096C85.3761 144.075 85.4575 144.056 85.5379 144.041C85.9187 143.97 86.2826 144.238 86.3574 144.644C86.4322 145.049 86.1902 145.445 85.8129 145.534C85.7341 145.553 85.6565 145.57 85.5797 145.586C84.4128 145.896 83.0618 146.999 82.2767 147.966C82.0347 148.264 81.6804 149.097 81.319 149.628C81.0523 150.02 80.7526 150.279 80.501 150.37C80.3323 150.431 80.1902 150.422 80.0727 150.391C79.9021 150.346 79.7605 150.247 79.6519 150.09C79.5928 150.003 79.5379 149.888 79.5117 149.741C79.4992 149.67 79.4978 149.49 79.4981 149.408C79.4244 149.137 79.3343 148.872 79.2686 148.598C79.1119 147.946 78.8045 147.532 78.4394 146.986C78.0979 146.475 77.7311 146.154 77.1934 145.898C77.1235 145.879 76.559 145.732 76.3597 145.647C76.0685 145.522 75.9298 145.314 75.8794 145.201C75.7938 145.011 75.785 144.844 75.8021 144.705C75.8274 144.501 75.9133 144.325 76.0657 144.184C76.1601 144.096 76.3011 144.01 76.4899 143.969C76.6358 143.936 77.0228 143.917 77.0771 143.914ZM80.3884 142.85C80.4145 142.913 80.4424 142.975 80.472 143.039C81.1021 144.386 81.8067 145.138 82.6632 145.503L82.6919 145.515C82.1189 145.97 81.6003 146.479 81.2039 146.967C81.0407 147.168 80.8246 147.585 80.5911 148.013C80.379 147.275 80.0321 146.753 79.5959 146.1C79.2626 145.602 78.9134 145.227 78.4844 144.922C78.8173 144.739 79.1349 144.524 79.4116 144.274C79.8723 143.858 80.1768 143.375 80.3884 142.85Z",
    fill: "#26AB3F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.698,
    cy: 222.098,
    r: 7.05071,
    fill: "#26AB3F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.634,
    cy: 236.199,
    r: 3.52536,
    fill: "#26AB3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_29494_251215_clip_path",
    transform: "translate(-87.7546 -41.3483)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 184.637,
    cy: 138.231,
    r: 58.5161
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_29494_251215",
    x: 99.4295,
    y: 34.1612,
    width: 187.817,
    height: 187.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.6263,
    dy: -11.6263
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5017
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.698039 0 0 0 0 0.968627 0 0 0 0 0.388235 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29494_251215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29494_251215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29494_251215",
    x1: 188.019,
    y1: 282.028,
    x2: 334.454,
    y2: 19.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29494_251215",
    x1: 234.856,
    y1: 100.849,
    x2: 89.0165,
    y2: 80.6829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29494_251215",
    x1: 244.616,
    y1: 76.791,
    x2: 155.909,
    y2: 180.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2F763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB3F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveImage);
export default __webpack_public_path__ + "static/media/approve-image.6d32388ad2ed6ee8f64e5a717b58320e.svg";
export { ForwardRef as ReactComponent };